/**
 * Apply a radial deadzone + smooth rescale to a stick reading, writing the result into `out`.
 * Inside the deadzone the output is zero; outside it, the magnitude is rescaled so it ramps from 0
 * at the deadzone edge to 1 at full deflection. Hot-path zero-allocation variant — `out` is reused.
 *
 * @param deadzone radius in [0, 1) below which the stick reads as centered.
 */
export function applyDeadzoneTo(
  out: { x: number; y: number },
  x: number,
  y: number,
  deadzone: number,
): void {
  const mag = Math.hypot(x, y);
  if (mag <= deadzone) {
    out.x = 0;
    out.y = 0;
    return;
  }
  const scale = (mag - deadzone) / (1 - deadzone) / mag;
  out.x = x * scale;
  out.y = y * scale;
}
